<div class="content p-24">

    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">{{'Add new card to'|translate}} {{user.firstName}} {{user.lastName}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Card number'|translate}}</mat-label>
                    <input matInput formControlName="cardNumber" required (input)="verifyCardNumber($event)">
                    <mat-icon matSuffix class="secondary-text" *ngIf="!checkingCardNumber">credit_card</mat-icon>
                    <mat-icon matSuffix class="secondary-text" *ngIf="checkingCardNumber">sync</mat-icon>
                    <mat-error>{{'Card number is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div class="row" style="color: red;" *ngIf="cardExists && cardNumber.length>0 && !checkingCardNumber">{{'Card number already exists!'|translate}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent" [disabled]="cardExists || cardNumber.length === 0">
                        {{'Save'|translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
